import {
  UnpaidInvoiceSort,
  UnpaidInvoiceSortField,
} from '@finance-hub/domain/invoicing/blocs/types/unpaid-invoice-list';

export const DEFAULT_UNPAID_INVOICE_SORT: UnpaidInvoiceSort = {
  direction: 'desc',
  field: 'daysOverdue',
};

/**
 * Returns the sort selection after a column header is pressed.
 *
 * Every column is sortable in both directions: pressing the active column
 * toggles its direction. Pressing a new column starts it ascending, except
 * the overdue column, whose first press starts descending ("most overdue
 * first", also the table's default) before toggling like the rest.
 *
 * @param current The active sort selection.
 * @param field The column header that was pressed.
 * @returns The next sort selection.
 */
export const getNextUnpaidInvoiceSort = (
  current: UnpaidInvoiceSort,
  field: UnpaidInvoiceSortField,
): UnpaidInvoiceSort => {
  if (current.field === field) {
    return {
      direction: current.direction === 'asc' ? 'desc' : 'asc',
      field,
    };
  }

  return {
    direction: field === 'daysOverdue' ? 'desc' : 'asc',
    field,
  };
};
